import { render } from "./PendingAccounts.vue?vue&type=template&id=e9de5954&scoped=true&ts=true"
import script from "./PendingAccounts.vue?vue&type=script&lang=ts"
export * from "./PendingAccounts.vue?vue&type=script&lang=ts"

import "./PendingAccounts.vue?vue&type=style&index=0&id=e9de5954&scoped=true&lang=sass"

import exportComponent from "/home/vaab/dev/js/monujo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-e9de5954"]])

export default __exports__